import { render, staticRenderFns } from "./UserNoteContactForm.vue?vue&type=template&id=2616fe4a"
import script from "./UserNoteContactForm.vue?vue&type=script&lang=js"
export * from "./UserNoteContactForm.vue?vue&type=script&lang=js"
import style0 from "./UserNoteContactForm.vue?vue&type=style&index=0&id=2616fe4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports